import React from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Button from '../../../../Core/Button/Button';
import Table1 from './Table1';
import Table2 from './Table2';

const GeneralDetailsTab1 = ({ formData, onFieldChange, extraData }) => {
    return (
        <div>
            <div className="px-4 py-4" style={{ background: 'white' }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                    <div
                        className=""
                        style={{
                            backgroundColor: '#EBE6FA',
                            height: '100%',
                            borderRadius: '4px',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            padding: '10px',
                        }}
                    >
                        <div style={{ display: 'flex', gap: '15px' }}>
                            {/* Naming Series */}
                            <div style={{ flex: 1 }}>
                                <Input
                                    label="Naming Series"
                                    style={{ height: '30px' }}
                                    value={formData.naming_series}
                                    onChange={(e) =>
                                        onFieldChange('naming_series', e.target.value)
                                    }
                                />
                            </div>

                            {/* Company */}
                            <div style={{ flex: 1 }}>
                                <Input
                                    label="Company"
                                    style={{ height: '30px' }}
                                    value={formData.company}
                                    onChange={(e) =>
                                        onFieldChange('company', e.target.value)
                                    }
                                />

                            </div>

                            {/* Melt By */}
                            <div style={{ flex: 1 }}>
                                <SelectSearch
                                    label="Melt By"
                                    style={{ height: '30px' }}
                                    value={formData.melt_by}
                                    list={extraData?.melt_by || []}
                                    getOptionLabel={(item) => item.name}
                                    getOptionValue={(item) => item.name}
                                    createNewUrl="/master/meltby/create"
                                    createNewLabel="Create New Melt By"
                                    onChange={(val) => onFieldChange('melt_by', val)}
                                />
                            </div>

                            {/* Melt Authorized */}
                            <div style={{ flex: 1 }}>
                                <SelectSearch
                                    label="Melt Authorized"
                                    style={{ height: '30px' }}
                                    value={formData.melt_authorized}
                                    list={extraData?.melt_authorized || []}
                                    getOptionLabel={(item) => item.name}
                                    getOptionValue={(item) => item.name}
                                    createNewUrl="/master/meltauthorized/create"
                                    createNewLabel="Create New Melt Authorized"
                                    onChange={(val) =>
                                        onFieldChange('melt_authorized', val)
                                    }
                                />
                            </div>

                            {/* Sales Person */}
                            <div style={{ flex: 1 }}>
                                <SelectSearch
                                    label="Sales Person"
                                    style={{ height: '30px' }}
                                    value={formData.sales_person}
                                    list={extraData?.sales_person || []}
                                    getOptionLabel={(item) => item.name}
                                    getOptionValue={(item) => item.name}
                                    createNewUrl="/master/salesperson/create"
                                    createNewLabel="Create New Sales Person"
                                    onChange={(val) =>
                                        onFieldChange('sales_person', val)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Transaction Type */}
                <div className="mt-4">
                    <p style={{ fontSize: '16px', fontWeight: '700' }}>Transaction Type</p>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            gap: '10px',
                        }}
                    >
                        <Button
                            onClick={() =>
                                onFieldChange('old_gold', !formData.old_gold)
                            }
                            iconSize={12}
                            className="createbtn border-0 d-flex"
                            style={{
                                gap: '2px',
                                height: '28px',
                                background: formData.old_gold ? '#E6A744' : '',
                            }}
                            iconName={'AiOutlinePlus'}
                        >
                            Old Gold
                        </Button>

                        <Button
                            onClick={() =>
                                onFieldChange('in_stock_item', !formData.in_stock_item)
                            }
                            iconSize={12}
                            className="createbtn border-0 d-flex"
                            style={{
                                gap: '2px',
                                height: '28px',
                                background: formData.in_stock_item ? '#E6A744' : '',
                            }}
                            iconName={'AiOutlinePlus'}
                        >
                            In Stock Item
                        </Button>
                    </div>
                    <div>
                        {formData.old_gold &&
                            <Table1
                                title="Old Gold"
                                setselected_item_data={[]}
                                createNewRow={[]}
                                columns={extraData.ItemColumnsTab1Table1}
                                rows={[]}
                                setRows={() => { }}
                                list_data={() => { }}
                                po_status={""}
                            />}


                        {formData.in_stock_item &&
                            <Table2
                                title="Serialized Item"
                                setselected_item_data={[]}
                                createNewRow={[]}
                                columns={extraData.ItemColumnsTab1Table2}
                                rows={[]}
                                setRows={() => { }}
                                list_data={() => { }}
                                po_status={""}
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GeneralDetailsTab1;
